<template>
    <button-base style-type="danger">
        <slot></slot>
    </button-base>
</template>
